import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Label, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import { useRole } from "components/Hooks/UserHooks";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import {
  COLOR_RESERVATION_USER_TYPE,
  COLOR_STATUS_JOB_POST,
  ENUM_STATUS_JOB_POST,
  LIST_OPTION_STATUS_JOB_POST,
  RESERVATION_USER_TYPE,
} from "helpers/constans";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  createJobPost,
  getJobPostDetail,
  updateJobPost,
} from "store/job-post/thunk";
import WorkingConditions from "./components/WorkingConditions";
import JobInformation from "./components/JobInformation";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import moment from "moment";
import { calculateDaysBetween } from "helpers/format";
import RegionSection from "./components/RegionSection";
import BannerPremiumSection from "./components/BannerPremiumSection";
import BasicInformation from "./components/BasicInformation";
import PurchaseInformation from "./components/PurchaseInformation";

export interface Props {
  id?: string;
  dataBenifits: any;
  dataConditions: any;
  dataRegions?: any;
  setLinkImage?: any;
  dataSection?: any;
  dataPlan?: any;
  dataPlanAll?: any;
  dataJobCategory?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const LIST_STATUS_JOB_POST_DISABLED = [
  ENUM_STATUS_JOB_POST.DRAFT,
  ENUM_STATUS_JOB_POST.EXPIRED,
  ENUM_STATUS_JOB_POST.CLOSED,
  ENUM_STATUS_JOB_POST.REJECTED,
];

const JobForm = ({
  id = "",
  dataBenifits,
  dataConditions,
  dataRegions,
  dataSection,
  dataPlan,
  dataPlanAll,
  triggerRefresh,
  onClose,
  setLinkImage,
  dataJobCategory
}: Props) => {
  const { t } = useTranslation();
  const { userPermissions } = useRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [listCheckedUsers, setListCheckedUsers] = useState<any>(null);
  const [dataStoreUser, setDataStoreUser] = useState<any>(null);
  const [dataJobPostDetail, setDataJobPostDetail] = useState<any>(null);
  const [lstStatusJobPost, setLstStatusJobPost] = useState<any>([]);
  const [statusDefault, setStatusDefault] = useState<any>("");
  const [typeNumberOfRecruits, setTypeNumberOfRecruits] = useState(1);
  const [listCheckedBannerPosition, setListCheckedBannerPosition] = useState<any>(null);
  const [planInformationChoose, setPlanInformationChoose] = useState<any>(null);
  const [sectionInformationChoose, setSectionInformationChoose] = useState<any>(null);
  const [dailyAmountPlan, setDailyAmountPlan] = useState<any>(0);
  const [userIDOld, setUserIDOld] = useState<any>(null);
  const [storeIDOld, setStoreIDOld] = useState<any>(null);
  // const [formatDataSection, setFormatDataSection] = useState<any>([]);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);
      const formatPurchaseInformation = {
        planId: values?.planId,
        sectionId: values?.sectionId || null,
        startDate: values?.purchaseStartDate ? moment.utc(values?.purchaseStartDate).format("YYYY-MM-DD") : "",
        endDate: values?.purchaseEndDate ? moment.utc(values?.purchaseEndDate).format("YYYY-MM-DD") : "",
        totalAmount: totalPriceFinal || 0,
        transfer: {
            "bankName": "KB국민은행",
            "bankAccount": "360101-04-197571",
            "bankHolder": "(주)믹스바이브",
            "depositorName": "Admin",
            "receiptEmail": "admin@gmail.com",
            "receiptType": "NONE",
            "description": ""
        }
      };

      const data = {
        item: {
          storeId: (id && values?.storeId != storeIDOld) ? storeIDOld : values?.storeId,
          userId: (id && values?.userId != userIDOld) ? userIDOld : Number.parseInt(values?.userId || 0),
          title: values?.title,
          gender: values?.gender,
          headCount: Number.parseInt(values?.headCount || 0),
          employmentType: values?.employmentType,
          durationWork: values?.durationWork,
          durationFlexible: values?.durationFlexible,
          ...(values?.salaryNegotiable === true
            ? {
                salaryType: "MONTHLY",
              }
            : {
                salaryType: values?.salaryType,
                salaryAmount: values?.salaryAmount,
              }),
          salaryNegotiable: values?.salaryNegotiable,
          jobDescription: values?.jobDescription,
          jobAttachment: values?.jobAttachment || [],
          // experienceRequired: values?.experienceRequired,
          workDays: values?.workDays,
          workTimeRange: [
            values?.workTimeRange?.startTime,
            values?.workTimeRange?.endTime,
          ]
            .filter(Boolean)
            .join("~"),
          workTimeFlexible: values?.workTimeFlexible,
          storeDescription: values?.storeDescription,
          storeAttachments: values?.storeAttachments,
          contactPhone: values?.contactPhone,
          contactEmail: values?.contactEmail,
          status: id ? values?.status : "ACTIVE",
          priorityRecruitment: values?.priorityRecruitment,
          jobCategoryId: values?.jobCategoryId || null,
          jobCategoryText: values?.jobCategoryText || "",
          ...(id
            ? {
                notes: values?.notes,
              }
            : null),
        },
        benefits: values?.benefits,
        preferences: values?.preferences,
        regions: values?.regions,
        ...((id && dataJobPostDetail?.banner) && (
          {
            bannerPremium: {
              ...values?.bannerPremium,
              bannerImage: values?.bannerPremium?.bannerImage?.[0]?.url || "",
              bgColor: values?.bannerPremium?.bgColor || "#FFFFFF",
            }
          }
        )),
        purchaseInformation: formatPurchaseInformation,
        ...((id && values?.userId != userIDOld) ? {newOwnerId: Number.parseInt(values?.userId || 0)} : null),
      };
      
      const response: any = id
        ? await updateJobPost(id, data)
        : await createJobPost(data);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
        onClose && onClose();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      // toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      toast(t("Invalid input"), CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    jobAttachment: Yup.array()
      .of(
        Yup.object({
          url: Yup.string().required(t("This field is required")),
        })
      )
      .max(5, t("You can only select up to 5 images")),
    storeId: Yup.number().required(`${t("This field is required")}`),
    planId: Yup.number().required(`${t("This field is required")}`),
    userId: Yup.string()
      .trim()
      .required(`${t("This field is required")}`),
    title: Yup.string()
      .trim()
      .required(`${t("This field is required")}`),
    durationWork: Yup.string().required(`${t("This field is required")}`),
    employmentType: Yup.string().required(`${t("This field is required")}`),
    priorityRecruitment: Yup.string().required(
      `${t("This field is required")}`
    ),
    jobDescription: Yup.string().required(`${t("This field is required")}`),
    workTimeRange: Yup.object({
      startTime: Yup.string(),
      endTime: Yup.string(),
    })
      .test(
        "validate-work-time",
        t("Working time validation failed"),
        function (value) {
          const { startTime, endTime } = value || {};
          const { isOvernight, workTimeFlexible } = this.parent;

          if (workTimeFlexible) return true; // Skip validation if flexible

          if (!startTime || !endTime)
            return this.createError({ message: t("This field is required") });

          const [startHour, startMinute] = startTime.split(":").map(Number);
          const [endHour, endMinute] = endTime.split(":").map(Number);

          const start = startHour * 60 + startMinute;
          let end = endHour * 60 + endMinute;

          if (isOvernight) {
            end += 1440;
          } else {
            if (end <= start) {
              return this.createError({
                message: t("End time must be later than start time"),
              });
            }
          }

          if (end - start < 180) {
            return this.createError({
              message: t("Working hours must be at least 3 hours"),
            });
          }

          return true;
        }
      )
      .when("workTimeFlexible", {
        is: false,
        then: (schema) =>
          schema.test(
            "workTimeRequired",
            t("This field is required"),
            (value) => !!value?.startTime && !!value?.endTime
          ),
      }),
    salaryType: Yup.string().when("salaryNegotiable", {
      is: false,
      then: (schema) => schema.required(t("This field is required")),
    }),
    salaryAmount: Yup.number()
      .nullable()
      .when(
        ["salaryNegotiable", "salaryType"],
        ([negotiable, type], schema) => {
          if (negotiable === false) {
            let min = 0;
            let message = "";

            switch (type) {
              case "HOURLY":
                min = 10030;
                message = "The hourly wage must be at least 10,030 KRW.";
                break;
              case "DAILY":
                min = 80240;
                message = "The daily wage must be at least 80,240 KRW.";
                break;
              case "WEEKLY":
                min = 481440;
                message = "The weekly wage must be at least 481,440 KRW.";
                break;
              case "MONTHLY":
                min = 2096270;
                message = "The monthly wage must be at least 2,096,270 KRW.";
                break;
              default:
                return schema.required(t("This field is required"));
            }

            return schema
              .required(t("This field is required"))
              .min(min, t(message));
          }

          return schema;
        }
      ),
    regions: Yup.array()
      .of(
        Yup.object().shape({
          regionId: Yup.number().nullable(),
          subRegionId: Yup.number().nullable(),
        })
      )
      .max(3, t("You can only select up to 3 regions")),
  });

  const formik = useFormik({
    initialValues: {
      storeId: null,
      userId: null,
      gender: "MALE",
      title: "",
      headCount: null,
      employmentType: "FULL_TIME",
      priorityRecruitment: "NORMAL",
      // experienceRequired: "NOT_REQUIRED",
      workDays: {
        MON: true,
        TUE: true,
        WED: true,
        THU: true,
        FRI: true,
        SAT: false,
        SUN: false,
      } as any,
      workTimeRange: {
        startTime: "",
        endTime: "",
      },
      durationFlexible: false,
      workTimeFlexible: false,
      salaryNegotiable: false,
      isOvernight: true,
      benefits: [],
      preferences: [],
      durationWork: "ONE_MONTH",
      salaryType: "",
      salaryAmount: null,
      jobDescription: "",
      jobAttachment: "",
      storeAttachments: null,
      contactPhone: "",
      contactEmail: "",
      storeDescription: "",
      status: "",
      note: "",
      regions: [],
      planId: null,
      sectionId: "",
      jobCategoryId: null,
      jobCategoryText: "",
      purchaseStartDate: new Date() as any,
      purchaseEndDate: new Date(moment().add(30, "days")) as any,
      vatAmount: 0,
      totalAmount: 0
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const getJobPostStatus = (status: string) => {
    switch (status) {
      case ENUM_STATUS_JOB_POST.PAYMENT_PENDING:
        setLstStatusJobPost(
          LIST_OPTION_STATUS_JOB_POST?.filter((item: any) =>
            [
              ENUM_STATUS_JOB_POST.PAYMENT_PENDING,
              ENUM_STATUS_JOB_POST.REJECTED,
            ]?.includes(item?.value)
          )
        );
        break;
      case ENUM_STATUS_JOB_POST.ACTIVE:
        setLstStatusJobPost(
          LIST_OPTION_STATUS_JOB_POST?.filter((item: any) =>
            [
              ENUM_STATUS_JOB_POST.ACTIVE,
              ENUM_STATUS_JOB_POST.PAUSED,
              ENUM_STATUS_JOB_POST.CLOSED,
              ENUM_STATUS_JOB_POST.REJECTED,
            ]?.includes(item?.value)
          )
        );
        break;
      case ENUM_STATUS_JOB_POST.PAUSED:
        setLstStatusJobPost(
          LIST_OPTION_STATUS_JOB_POST?.filter((item: any) =>
            [
              ENUM_STATUS_JOB_POST.ACTIVE,
              ENUM_STATUS_JOB_POST.CLOSED,
            ]?.includes(item?.value)
          )
        );
        break;
      default:
        setLstStatusJobPost(LIST_OPTION_STATUS_JOB_POST);
        break;
    }
  };

  const handleSetValueForm = (itemJobPost: any) => {
    setDataJobPostDetail(itemJobPost);

    const objUser = itemJobPost?.store?.user;
    const dataStore = itemJobPost?.store;
    const vUser = objUser && {
      value: objUser?.id,
      label: (
        <div className="d-flex align-items-center gap-2">
          <div
            style={{
              height: "30px",
              width: "30px",
              minWidth: "30px",
              overflow: "hidden",
              borderRadius: "15px",
              objectFit: "cover",
              backgroundColor: "#eaeaea",
              zIndex: 99,
            }}
          >
            <img
              src={dataStore?.thumbnailUrl || NO_IMAGE_USER}
              alt={dataStore?.managerName}
              height={30}
              width={30}
              style={{
                minWidth: "30px",
                overflow: "hidden",
                borderRadius: "50%",
                objectFit: "cover",
                backgroundColor: "#eaeaea",
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = NO_IMAGE_USER;
              }}
            />
          </div>

          <div>
            <span
              className={`rounded-pill badge bg-${
                COLOR_RESERVATION_USER_TYPE[dataStore?.user?.type] ||
                "secondary"
              }`}
            >
              {t(
                RESERVATION_USER_TYPE?.find(
                  (item: any) =>
                    String(item?.value) === String(dataStore?.user?.type)
                )?.label || ""
              )}
            </span>

            <div className="d-flex flex-column">
              {dataStore ? (
                <>
                  <div>
                    {[dataStore?.managerName, dataStore?.managerEmail]
                      .filter(Boolean)
                      .join(" - ")}
                  </div>
                  <div>
                    {dataStore?.name} {" - "}
                    <small className="text-secondary">
                      {dataStore?.user?.storeBusiness?.businessNumber}
                    </small>
                  </div>
                  <small className="text-secondary">
                    {dataStore?.address?.shortAddress}
                  </small>
                </>
              ) : (
                <div>
                  <small>{t("Email SNS")}:</small> {objUser?.email}
                </div>
              )}
            </div>
          </div>
        </div>
      ),
      data: objUser,
    };
    setListCheckedUsers(vUser);

    setDataStoreUser(itemJobPost?.store);
    const workingTime = itemJobPost?.workTimeRange
      ? itemJobPost?.workTimeRange?.split(/~|-/)
      : "";
    const startTime = workingTime?.[0]?.trim() || "";
    const endTime = workingTime?.[1]?.trim() || "";

    getJobPostStatus(itemJobPost?.status);
    setStatusDefault(itemJobPost?.status);
    setTypeNumberOfRecruits(itemJobPost?.headCount);

    // banner premium start
    const sectionId = itemJobPost?.banner ? itemJobPost?.banner?.id : "";
    const dataBannerPosition = itemJobPost?.sectionItems || [];
    const bannerPositions = (dataBannerPosition || []).filter(
      (item: any) => item?.bannerPositionId && item?.bannerImage
    );
    const bannerPremium = bannerPositions?.[0]?.bannerImage || "";
    const bannerBgColor = bannerPositions?.[0]?.bgColor || "";

    let formatBannerPositionIds = [];
    if (bannerPositions?.length > 0) {
      const formatBannerPosition = (bannerPositions || []).map((item: any) => ({
        value: item?.bannerPositionId,
        label: (
          <div className="d-flex align-items-center gap-2">
            <div>
              {`${item?.bannerPosition?.name} - `}{" "}
              <small className="text-warning">
                {item?.bannerPosition?.positionCode}
              </small>
            </div>
          </div>
        ),
      }));

      formatBannerPositionIds = (bannerPositions || []).map(
        (item: any) => item?.bannerPositionId
      );

      setListCheckedBannerPosition(formatBannerPosition);
    }
    // banner premium end

    // Purchase Information start
    const planPurchases = itemJobPost?.planPurchases?.[0];
    const orderItems = planPurchases?.payment?.order?.orderItems;
    const sectionIdFormat = orderItems?.find((item?:any) => item?.productType === "SECTION")?.productId || null;
    const planIdFormat = planPurchases?.payment?.method === "FREE" ? planPurchases?.planId : orderItems?.find((item?:any) => item?.productType === "PLAN")?.productId;

    // Purchase Information end
    setUserIDOld(Number.parseInt(itemJobPost?.userId))
    setStoreIDOld(Number.parseInt(itemJobPost?.storeId))
    const formatValue = {
      storeId: itemJobPost?.storeId,
      userId: itemJobPost?.userId,
      gender: itemJobPost?.gender,
      title: itemJobPost?.title,
      headCount: itemJobPost?.headCount,
      employmentType: itemJobPost?.employmentType,
      priorityRecruitment: itemJobPost?.priorityRecruitment,
      // experienceRequired: itemJobPost?.experienceRequired,
      workDays: itemJobPost?.workDays,
      workTimeRange: {
        startTime: startTime,
        endTime: endTime,
      },
      durationFlexible:
        itemJobPost?.workDays?.NEGOTIABLE || itemJobPost?.durationFlexible,
      workTimeFlexible: itemJobPost?.workTimeFlexible,
      salaryNegotiable: itemJobPost?.salaryNegotiable,
      isOvernight: itemJobPost?.isOvernight || true,
      benefits: itemJobPost?.benefits,
      preferences: itemJobPost?.preferences,
      durationWork: itemJobPost?.durationWork,
      salaryType: itemJobPost?.salaryType,
      salaryAmount: itemJobPost?.salaryAmount,
      jobDescription: itemJobPost?.jobDescription,
      jobAttachment: itemJobPost?.jobAttachment,
      storeAttachments: itemJobPost?.storeAttachments,
      contactPhone: itemJobPost?.contactPhone,
      contactEmail: itemJobPost?.contactEmail,
      storeDescription: itemJobPost?.storeDescription,
      status: itemJobPost?.status,
      note: itemJobPost?.note,
      regions: itemJobPost?.regions,
      ...(sectionId
        ? {
            bannerPremium: {
              sectionId: sectionId,
              bannerPositionIds: formatBannerPositionIds,
              bannerImage: bannerPremium ? [{ url: bannerPremium }] : "",
              bgColor: bannerBgColor || "#FFFFFF",
            },
          }
        : null),

      planId: planIdFormat,
      sectionId: sectionIdFormat,
      purchaseStartDate: itemJobPost?.displayStartDate
        ? moment.utc(itemJobPost?.displayStartDate).startOf("day").toDate()
        : null,
      purchaseEndDate: itemJobPost?.displayEndDate
        ? moment.utc(itemJobPost?.displayEndDate).startOf("day").toDate()
        : null,
      vatAmount: itemJobPost?.planPurchases?.[0]?.payment?.order?.vatAmount || 0,
      totalAmount: itemJobPost?.planPurchases?.[0]?.payment?.order?.totalAmount || 0,
      jobCategoryId: itemJobPost?.jobCategoryId || "",
      jobCategoryText: itemJobPost?.jobCategoryText || "",
    };
    formik.setValues(formatValue);
  };

  const getJobPostById = async (idItem: string) => {
    if (!idItem) return;

    try {
      const resDetail: any = await getJobPostDetail(idItem);

      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
      }
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    getJobPostById(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  const handleCheckDaily = () => {
    const startDate = formik?.values?.purchaseStartDate || null;
    let endDate = formik?.values?.purchaseEndDate || null;

    if (
      startDate &&
      endDate &&
      !isNaN(startDate.getTime()) &&
      !isNaN(endDate.getTime())
    ) {
      const days = calculateDaysBetween(startDate, endDate);
      let totalAmount = planInformationChoose?.priceFinal || 0;

      if (days > 0 && planInformationChoose?.priceFinal) {
        totalAmount = days * planInformationChoose?.priceFinal;
      }

      setDailyAmountPlan(totalAmount)
    }
  };

  useEffect(() => {
    if(!sectionInformationChoose && !planInformationChoose) return;
    if (!planInformationChoose?.durationDays && !planInformationChoose?.maxUsage) return;

    const startDate = formik?.values?.purchaseStartDate || null;
    if (startDate) {
      const durationDays = planInformationChoose?.durationDays
        ? planInformationChoose?.durationDays
        : 30;
      const endDate = new Date(startDate);

      endDate.setDate(startDate.getDate() + durationDays);
      formik.setFieldValue("purchaseEndDate", endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.purchaseStartDate]);

  useEffect(() => {
    if(!sectionInformationChoose && !planInformationChoose) return;

    if (!planInformationChoose?.durationDays && !planInformationChoose?.maxUsage) {
      handleCheckDaily();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.purchaseStartDate, formik?.values?.purchaseEndDate]);


  useEffect(() => {
    if((!sectionInformationChoose && !planInformationChoose)) return;

    if (formik?.values?.planId) {
      formik.setFieldValue("purchaseStartDate", new Date());
      formik.setFieldValue("purchaseEndDate", new Date());
      setDailyAmountPlan(planInformationChoose?.priceFinal);
      if (planInformationChoose?.priceType === "FREE") {
        const startDate = new Date();
        const endDate = new Date(startDate);
        endDate.setDate(
          startDate.getDate() + planInformationChoose?.durationDays
        );

        formik.setFieldValue("purchaseStartDate", startDate);
        formik.setFieldValue("purchaseEndDate", endDate);
      } else if (
        planInformationChoose?.durationDays &&
        !planInformationChoose?.maxUsage
      ) {
        const startDate = formik?.values?.purchaseStartDate || new Date();
        let endDate = null;
        if (startDate) {
          endDate = new Date(startDate);
          endDate.setDate(
            startDate.getDate() + planInformationChoose?.durationDays
          );
        }
        formik.setFieldValue("purchaseStartDate", startDate);
        formik.setFieldValue("purchaseEndDate", endDate);
      } else if (
        !planInformationChoose?.durationDays &&
        !planInformationChoose?.maxUsage
      ) {
        const endDate = new Date();
        endDate?.setDate(endDate?.getDate() + 1);
        formik.setFieldValue("purchaseStartDate", new Date());
        formik.setFieldValue("purchaseEndDate", endDate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.planId, sectionInformationChoose]);

  const totalPriceFinal = useMemo(() => {
    if(!sectionInformationChoose && !planInformationChoose) return;

    const totalAmount = (Number(dailyAmountPlan) + Number(sectionInformationChoose?.priceFinal || 0));
    const vatAmount = totalAmount * Number(planInformationChoose?.vatRate / 100);
    formik.setFieldValue("vatAmount", vatAmount)
    formik.setFieldValue("totalAmount", (totalAmount + vatAmount) || 0)

    return (totalAmount + vatAmount) || 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dailyAmountPlan, sectionInformationChoose, planInformationChoose]);

  return (
    <React.Fragment>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={8} lg={8}>
              <BasicInformation id={id} formik={formik} listCheckedUsers={listCheckedUsers} setListCheckedUsers={setListCheckedUsers} dataStoreUser={dataStoreUser} setDataStoreUser={setDataStoreUser}
               typeNumberOfRecruits={typeNumberOfRecruits} setTypeNumberOfRecruits={setTypeNumberOfRecruits} formatJobCategories={dataJobCategory} />
            </Col>
            <Col md={4} lg={4}>
              <PurchaseInformation formik={formik} dataSection={dataSection} dataPlan={dataPlan} dataPlanAll={dataPlanAll}
                setSectionInformationChoose={setSectionInformationChoose} setPlanInformationChoose={setPlanInformationChoose} id={id} 
              />
            </Col>
          </Row>

          <WorkingConditions formik={formik} />

          <RegionSection formik={formik} dataRegions={dataRegions} />

          <JobInformation
            formik={formik}
            dataBenifits={dataBenifits}
            dataConditions={dataConditions}
            setLinkImage={setLinkImage}
          />

          {id && (
            <>
              <Col md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="status" className="form-label">
                    {t("Status")} <span className="text-danger">*</span>
                  </Label>
                  <DropdownStatusNew
                    name="status"
                    dataList={lstStatusJobPost || []}
                    placeholder={`${t("Status")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.status}
                    onChangeSelect={(e: any) => {
                      formik.setFieldValue("status", e?.value);
                    }}
                    isHasOptionAll={false}
                    colors={COLOR_STATUS_JOB_POST}
                    disabled={
                      LIST_STATUS_JOB_POST_DISABLED?.includes(statusDefault)
                        ? true
                        : false
                    }
                  />
                  {formik.touched.status && formik.errors.status ? (
                    <div className="text-danger mt-2">
                      {formik.errors.status}
                    </div>
                  ) : null}
                </div>
              </Col>
            </>
          )}

          {(id && dataJobPostDetail?.banner && dataJobPostDetail?.status === "ACTIVE") && (
            <BannerPremiumSection
              formik={formik}
              listCheckedBannerPosition={listCheckedBannerPosition}
              setListCheckedBannerPosition={setListCheckedBannerPosition}
            />
          )}

          <Row>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {isHavePermissionRole(
                  ROLES_FOR_APP.USER_UPDATE,
                  userPermissions
                ) && (
                  <button type="submit" className="btn btn-primary fs-14">
                    {isLoading ? (
                      <Spinner size="sm" className="me-2"></Spinner>
                    ) : !!id ? (
                      <i className="ri-login-circle-line align-bottom me-2 "></i>
                    ) : (
                      <i className="ri-add-fill align-bottom me-2"></i>
                    )}
                    {id ? t("Button Update") : t("Button Create")}
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </form>
      </div>

      <ToastContainer closeButton={false} limit={1} />
    </React.Fragment>
  );
};

export default JobForm;
